(function () {
  'use strict';

  var CONFETTI_COLORS = ['#E8A838', '#2D6A4F', '#F4A261', '#4ABFAA', '#E8D5B7'];

  var KEY_MILESTONES  = 'ml_milestones';
  var KEY_WORDS       = 'ml_words';
  var KEY_ML_PREFS    = 'ml_prefs';
  var KEY_FT_PREFS    = 'ft_prefs';
  var KEY_DT_PREFS    = 'dt_prefs';
  var KEY_BL_PREFS    = 'bl_prefs';
  var KEY_FT_SESSIONS = 'ft_sessions';
  var KEY_DT_SESSIONS = 'dt_sessions';
  var KEY_BL_LOGS     = 'bl_logs';

  var WORD_COUNT_THRESHOLDS = [1, 5, 10, 20, 50, 100];
  var WORD_COUNT_NAMES = {
    1: 'First real word',
    5: '5 words',
    10: '10 words',
    20: '20 words — on the way',
    50: '50 words — the explosion begins',
    100: '100 words',
  };

  var CATEGORIES = {
    motor: {
      label: 'Motor', emoji: '🏃', year: 0,
      items: [
        { name: 'Lifted head during tummy time', year: 1 },
        { name: 'Holds head steady', year: 1 },
        { name: 'Rolled tummy to back', year: 1 },
        { name: 'Rolled both ways', year: 1 },
        { name: 'Sat with support', year: 1 },
        { name: 'Sat without support', year: 1 },
        { name: 'Started crawling', year: 1 },
        { name: 'Pulled to stand', year: 1 },
        { name: 'Cruised along furniture', year: 1 },
        { name: 'First steps', year: 1 },
        { name: 'Walks independently', year: 2 },
        { name: 'Walks steadily without falling', year: 2 },
        { name: 'Climbs onto furniture', year: 2 },
        { name: 'Walks up stairs with help', year: 2 },
        { name: 'Runs (that wonderful unsteady sprint)', year: 2 },
        { name: 'Kicks a ball', year: 2 },
        { name: 'Squats and stands back up', year: 2 },
        { name: 'Jumps with both feet', year: 2 },
        { name: 'Feeds self with spoon', year: 2 },
        { name: 'Scribbles with a crayon', year: 2 },
        { name: 'Stacks 4+ blocks', year: 2 },
        { name: 'Throws a ball overhand', year: 2 },
      ],
    },
    communication: {
      label: 'Language', emoji: '💬', year: 0,
      items: [
        { name: 'First coo', year: 1 },
        { name: 'Babbles (consonant sounds)', year: 1 },
        { name: 'Laughs out loud', year: 1 },
        { name: 'Responds to own name', year: 1 },
        { name: 'Says "mama" (directed)', year: 1 },
        { name: 'Says "dada" (directed)', year: 1 },
        { name: 'First recognisable word', year: 1 },
        { name: 'Points to things', year: 1 },
        { name: '5 words in vocabulary', year: 2 },
        { name: '10 words in vocabulary', year: 2 },
        { name: 'Follows a simple instruction', year: 2 },
        { name: 'Shakes head for no', year: 2 },
        { name: 'Points to body parts when named', year: 2 },
        { name: 'Names familiar objects', year: 2 },
        { name: 'First two-word combination', year: 2 },
        { name: '50 words in vocabulary', year: 2 },
        { name: 'Word explosion begins', year: 2 },
        { name: 'Uses own name to refer to self', year: 2 },
        { name: 'First three-word phrase', year: 2 },
      ],
    },
    social: {
      label: 'Social', emoji: '😊', year: 0,
      items: [
        { name: 'First real smile', year: 1 },
        { name: 'First laugh', year: 1 },
        { name: "Recognises parent's face", year: 1 },
        { name: 'Reaches for people', year: 1 },
        { name: 'Stranger awareness', year: 1 },
        { name: 'Waves bye-bye', year: 1 },
        { name: 'Claps hands', year: 1 },
        { name: 'Plays peek-a-boo', year: 1 },
        { name: 'Gives hugs and kisses (unprompted)', year: 2 },
        { name: 'Shows empathy — comforts an upset person', year: 2 },
        { name: 'Laughs at something intentionally funny', year: 2 },
        { name: 'Says "no" and means it', year: 2 },
        { name: 'Parallel play — plays near other children', year: 2 },
        { name: 'Offers a toy to another child', year: 2 },
        { name: "Shows pride in something they've done", year: 2 },
        { name: 'Asks for help', year: 2 },
        { name: 'First real tantrum', year: 2 },
        { name: 'Says "I love you"', year: 2 },
      ],
    },
    feeding: {
      label: 'Feeding', emoji: '🍼', year: 0,
      items: [
        { name: 'First solid food', year: 1 },
        { name: 'First self-feeding with hands', year: 1 },
        { name: 'First allergen introduced', year: 1 },
        { name: 'Holds own bottle', year: 1 },
        { name: 'Drinks from sippy cup', year: 1 },
        { name: 'Eats with spoon independently', year: 2 },
        { name: 'Drinks from an open cup', year: 2 },
        { name: 'Eats the same meal as the family', year: 2 },
        { name: 'Refuses a food dramatically', year: 2 },
        { name: 'Tries and loves something unexpected', year: 2 },
        { name: 'Asks for a specific food by name', year: 2 },
      ],
    },
    family: {
      label: 'Family', emoji: '👨‍👩‍👧', year: 0,
      items: [
        { name: 'First bath at home', year: 1 },
        { name: 'First time outside', year: 1 },
        { name: 'First car journey', year: 1 },
        { name: 'First overnight away from home', year: 1 },
        { name: 'First holiday / trip', year: 1 },
        { name: 'First playdate', year: 1 },
        { name: 'First haircut', year: 1 },
        { name: 'First swimming', year: 1 },
        { name: 'First birthday', year: 1 },
        { name: 'First words to a pet', year: 2 },
        { name: 'First time at the beach', year: 2 },
        { name: 'First time on a swing', year: 2 },
        { name: 'First time in snow', year: 2 },
        { name: 'First time at nursery', year: 2 },
        { name: 'First time in a pool', year: 2 },
        { name: 'First time at a playground', year: 2 },
        { name: 'Second birthday', year: 2 },
      ],
    },
    cognitive: {
      label: 'Play & Mind', emoji: '🧩', year: 2,
      items: [
        { name: 'Points to share something (not to ask)', year: 2 },
        { name: 'Imitates adult actions', year: 2 },
        { name: 'Finds a hidden object', year: 2 },
        { name: 'Pretend play begins', year: 2 },
        { name: 'Sorts shapes into a shape sorter', year: 2 },
        { name: 'Matches similar objects', year: 2 },
        { name: 'Simple cause-and-effect play', year: 2 },
        { name: 'Stacks and knocks down intentionally', year: 2 },
        { name: 'Turns pages of a book', year: 2 },
        { name: 'Recognises self in mirror', year: 2 },
        { name: 'Completes a 2–3 piece puzzle', year: 2 },
        { name: 'Understands "mine" and "yours"', year: 2 },
      ],
    },
    self_care: {
      label: 'Self-Care', emoji: '🌟', year: 2,
      items: [
        { name: 'Holds cup independently', year: 2 },
        { name: 'Uses a spoon to feed self', year: 2 },
        { name: 'Takes off socks or shoes', year: 2 },
        { name: 'Helps with dressing', year: 2 },
        { name: 'Brushes teeth with help', year: 2 },
        { name: 'Washes hands with help', year: 2 },
        { name: 'First potty success', year: 2 },
        { name: 'Sleeps through the night consistently', year: 2 },
        { name: 'Uses a fork', year: 2 },
      ],
    },
    custom: { label: 'Custom', emoji: '✨', year: 0, items: [] },
  };

  var WEEKLY_PROMPTS = [
    { maxWeeks: 2,   emoji: '🌱', text: 'Did baby open their eyes and look at your face today?' },
    { maxWeeks: 4,   emoji: '✨', text: 'Did you notice baby tracking a moving toy with their eyes?' },
    { maxWeeks: 8,   emoji: '😊', text: 'Has baby smiled at you yet? Log their first social smile!' },
    { maxWeeks: 12,  emoji: '🎵', text: 'Is baby starting to coo and make sounds? Capture it!' },
    { maxWeeks: 16,  emoji: '🤲', text: 'Did baby reach for or grab a toy today?' },
    { maxWeeks: 20,  emoji: '🔄', text: 'Is baby rolling over yet? Log that first flip!' },
    { maxWeeks: 24,  emoji: '🍼', text: 'Tried any first foods yet? Log that first purée!' },
    { maxWeeks: 28,  emoji: '🧸', text: 'Is baby sitting with support? Log that milestone!' },
    { maxWeeks: 32,  emoji: '🏃', text: 'Baby crawling yet? Log that first crawl!' },
    { maxWeeks: 36,  emoji: '📢', text: 'Any "mama" or "dada" sounds? Log that first word attempt!' },
    { maxWeeks: 40,  emoji: '🚀', text: 'Is baby pulling up to stand? Log that big moment!' },
    { maxWeeks: 44,  emoji: '💬', text: "Any pointing at things? That's a huge communication leap." },
    { maxWeeks: 48,  emoji: '🍽️', text: 'Is baby feeding themselves with their hands? Log it!' },
    { maxWeeks: 52,  emoji: '👣', text: 'First steps coming soon — watch for them and log every attempt!' },
    { maxWeeks: 54,  emoji: '🪜', text: 'Has baby started attempting stairs?' },
    { maxWeeks: 58,  emoji: '🧹', text: 'Has baby started imitating things you do? Sweeping, wiping?' },
    { maxWeeks: 62,  emoji: '👉', text: 'Is baby pointing at things just to show you, not because they want them?' },
    { maxWeeks: 66,  emoji: '💬', text: 'Two words together are coming. Any "more juice" or "daddy go"?' },
    { maxWeeks: 70,  emoji: '🧸', text: 'Has baby started pretend play — feeding a toy, "driving" something?' },
    { maxWeeks: 74,  emoji: '📝', text: 'The word explosion can happen any time now. How many words do they have?' },
    { maxWeeks: 78,  emoji: '🙅', text: "Has baby started saying \"no\" with real conviction? That's a milestone." },
    { maxWeeks: 82,  emoji: '🤗', text: 'Some children show empathy around 18 months — has baby tried to comfort someone?' },
    { maxWeeks: 88,  emoji: '🗣️', text: 'Is baby asking for specific things by name? ("Milk." "Book." "Outside.")' },
    { maxWeeks: 92,  emoji: '😤', text: 'Has baby had their first real tantrum? (Completely normal — worth noting.)' },
    { maxWeeks: 96,  emoji: '💬', text: 'Three-word phrases are coming. "Want more milk." Any early signs?' },
    { maxWeeks: 100, emoji: '📖', text: 'Second birthday is two months away. Start thinking about the book?' },
    { maxWeeks: 104, emoji: '🎂', text: "They turn 2 soon. What's the one thing you want to remember most about this year?" },
    { maxWeeks: 9999, emoji: '🌟', text: 'What new thing did baby discover this week?' },
  ];

  var MONTHLY_PROMPTS = [
    { maxMonths: 1,  emoji: '🌱', text: "What surprised you most in baby's first weeks?" },
    { maxMonths: 3,  emoji: '😊', text: "What's your favourite thing about this stage?" },
    { maxMonths: 6,  emoji: '🍼', text: 'How has daily life changed since those early weeks?' },
    { maxMonths: 9,  emoji: '🏃', text: 'What are they learning this month?' },
    { maxMonths: 12, emoji: '🎂', text: 'A whole year. What do you want to remember most?' },
    { maxMonths: 15, emoji: '🗣️', text: 'What words do they have now? What are they learning?' },
    { maxMonths: 18, emoji: '🧩', text: 'What is baby obsessed with this month?' },
    { maxMonths: 21, emoji: '💬', text: 'Describe a typical conversation with your toddler right now.' },
    { maxMonths: 24, emoji: '🎂', text: "Two years. Write them a letter for when they're older." },
    { maxMonths: 9999, emoji: '🌿', text: "What's delighting you about your baby this month?" },
  ];

  // AI proxy
  var LOCAL_DEV_RX   = /^(localhost|127\.0\.0\.1|.*\.local)$/i;
  var STAGING_WORKER = 'https://birch-ai-edge.api-staging.birchstore.com/apps/ai';
  function resolveAIProxy() {
    var theme = window.Theme;
    if (theme && theme.routes && theme.routes.aiProxy) return theme.routes.aiProxy;
    return LOCAL_DEV_RX.test(window.location.hostname) ? STAGING_WORKER : '/apps/ai';
  }

  // Multi-child context
  var _mlCtx         = { childName: null, childId: null, dob: null };
  var _mlAllContexts = [];

  // State
  var milestones      = [];
  var wordLogs        = [];
  var babyName        = 'Baby';
  var babyBirthdate   = null;
  var gestationalAge  = 40;
  var promptDismissed = false;
  var smartDismissed  = false;
  var wordLogActivated  = false;
  var journalCadence    = 'weekly';
  var firstsYearFilter  = 'all';
  var pendingWordMilestone = null;

  var flow = {
    step: 'pick', cat: 'motor', milestoneName: '', photoDataUrl: '',
    narrative: '', crossCtx: '', milestoneYear: 1, isAuto: false,
  };

  // Multi-child helpers
  async function hydrateFromSharedProfile() {
    if (!window.BirchChildren) return;
    try {
      var BC  = window.BirchChildren;
      var allCtxs = (await BC.load()).map(function(c) {
        return { childName: c.name, childId: c.id, dob: c.dob };
      });
      _mlAllContexts = allCtxs;
      if (allCtxs.length === 0) return;
      var ctx = allCtxs[0];
      _mlCtx        = ctx;
      babyName      = ctx.childName || babyName;
      babyBirthdate = ctx.dob ? new Date(ctx.dob) : babyBirthdate;
      updateChildSelectorLabel();
    } catch (e) {}
  }

  function updateChildSelectorLabel() {
    var name  = _mlCtx.childName || babyName || 'Select child';
    var label = document.getElementById('ml-child-selector-label');
    var wrap  = document.getElementById('ml-child-selector-wrap');
    if (label) label.textContent = name;
    if (wrap)  wrap.style.display = _mlAllContexts.length > 1 ? '' : 'none';
  }

  async function switchMilestoneChild() {
    if (!window.BirchChildren || _mlAllContexts.length < 2) return;
    var ctx = await window.BirchChildren.pickContext(_mlAllContexts, { title: 'Whose milestones?' });
    if (!ctx) return;
    _mlCtx        = ctx;
    babyName      = ctx.childName || babyName;
    babyBirthdate = ctx.dob ? new Date(ctx.dob) : babyBirthdate;
    updateChildSelectorLabel();
    renderTopbar();
    renderTimeline();
    renderFirstsGrid();
  }

  // Data
  function loadData() {
    try { milestones = JSON.parse(localStorage.getItem(KEY_MILESTONES) || '[]'); } catch { milestones = []; }
    try { wordLogs   = JSON.parse(localStorage.getItem(KEY_WORDS)      || '[]'); } catch { wordLogs = []; }

    var mlPrefs = null;
    try { mlPrefs = JSON.parse(localStorage.getItem(KEY_ML_PREFS) || '{}'); } catch {}
    if (mlPrefs) {
      if (mlPrefs.wordLogActivated) wordLogActivated = true;
      if (mlPrefs.journalCadence)   journalCadence   = mlPrefs.journalCadence;
    }

    var prefs = null;
    try { prefs = JSON.parse(localStorage.getItem(KEY_FT_PREFS) || '{}'); } catch {}
    if (!prefs || !prefs.babyName) {
      try { prefs = JSON.parse(localStorage.getItem(KEY_DT_PREFS) || '{}'); } catch {}
    }
    if (!prefs || !prefs.babyName) {
      try { prefs = JSON.parse(localStorage.getItem(KEY_BL_PREFS) || '{}'); } catch {}
    }
    if (prefs && prefs.babyName)      babyName      = prefs.babyName;
    if (prefs && prefs.babyBirthdate) babyBirthdate = new Date(prefs.babyBirthdate);
    if (prefs && prefs.gestationalAge) gestationalAge = prefs.gestationalAge;
  }

  function saveData() {
    try { localStorage.setItem(KEY_MILESTONES, JSON.stringify(milestones)); } catch {}
    try { localStorage.setItem(KEY_WORDS, JSON.stringify(wordLogs)); } catch {}
  }

  function savePrefs() {
    try {
      localStorage.setItem(KEY_ML_PREFS, JSON.stringify({
        wordLogActivated: wordLogActivated,
        journalCadence: journalCadence,
      }));
    } catch {}
  }

  // Age helpers
  function getAgeMonths() {
    if (!babyBirthdate) return null;
    var adj = babyBirthdate.getTime() - ((40 - (gestationalAge || 40)) * 7 * 86400000);
    return Math.floor((Date.now() - adj) / (30.44 * 86400000));
  }

  function getStage() {
    var m = getAgeMonths();
    if (m === null) return 1;
    if (m < 3)  return 1;
    if (m < 6)  return 2;
    if (m < 12) return 3;
    if (m < 18) return 4;
    return 5;
  }

  function computeBabyAge() {
    if (!babyBirthdate) return null;
    var diffMs   = Date.now() - babyBirthdate.getTime();
    var diffDays = Math.floor(diffMs / 86400000);
    var weeks    = Math.floor(diffDays / 7);
    var months   = Math.floor(diffDays / 30.44);
    var years    = Math.floor(diffDays / 365.25);
    var label;
    if (years >= 2)       label = years + ' years old';
    else if (months >= 1) label = months + ' month' + (months !== 1 ? 's' : '') + ' old';
    else if (weeks >= 1)  label = weeks  + ' week'  + (weeks  !== 1 ? 's' : '') + ' old';
    else                  label = diffDays + ' day' + (diffDays !== 1 ? 's' : '') + ' old';
    return { label: label, weeks: weeks, months: months };
  }

  function ageAtDate(iso) {
    if (!babyBirthdate) return '';
    var diffMs   = new Date(iso).getTime() - babyBirthdate.getTime();
    if (diffMs < 0) return '';
    var diffDays = Math.floor(diffMs / 86400000);
    var weeks    = Math.floor(diffDays / 7);
    var months   = Math.floor(diffDays / 30.44);
    if (months >= 1) return months + 'mo';
    if (weeks  >= 1) return weeks  + 'w';
    return diffDays + 'd';
  }

  function formatDate(iso) {
    return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function todayIso() {
    return new Date().toISOString().slice(0, 10);
  }

  // Stage-based UI
  function applyStageUI(stage) {
    var months = getAgeMonths() || 0;

    // Word log: show tab at 10+ months if activated, show unlock prompt at 10+
    var wordTab   = document.getElementById('ml-tab-words');
    var wordBadge = document.getElementById('ml-word-badge');
    if (wordTab) wordTab.style.display = wordLogActivated ? '' : 'none';
    if (wordBadge) wordBadge.style.display = (stage >= 4 && wordLogActivated) ? 'flex' : 'none';

    // Year 2 category pills
    var cogPill  = document.getElementById('ml-pill-cognitive');
    var scPill   = document.getElementById('ml-pill-self_care');
    if (cogPill) cogPill.style.display  = stage >= 4 ? '' : 'none';
    if (scPill)  scPill.style.display   = stage >= 4 ? '' : 'none';

    // Year filter only useful in stage 4+
    var yfRow = document.getElementById('ml-year-filter');
    if (yfRow) yfRow.style.display = stage >= 4 ? 'flex' : 'none';

    // Word log section in settings
    var wlSub = document.getElementById('ml-settings-wordlog-sub');
    var wlBtn = document.getElementById('ml-settings-wordlog-toggle');
    if (wordLogActivated) {
      if (wlSub) wlSub.textContent = 'Word Log is active.';
      if (wlBtn) wlBtn.textContent = 'Disable Word Log';
    }

    // Journal cadence buttons
    var cwBtn = document.getElementById('ml-cadence-weekly');
    var cmBtn = document.getElementById('ml-cadence-monthly');
    if (cwBtn) cwBtn.classList.toggle('ml-cadence-btn--active', journalCadence === 'weekly');
    if (cmBtn) cmBtn.classList.toggle('ml-cadence-btn--active', journalCadence === 'monthly');
  }

  // Cross-tracker context
  function computeCrossTrackerCtx() {
    var parts   = [];
    var months  = getAgeMonths() || 0;
    var stage   = getStage();
    var last24h = Date.now() - 86400000;

    try {
      var ftSessions = JSON.parse(localStorage.getItem(KEY_FT_SESSIONS) || '[]');
      var recentFt   = ftSessions.filter(function (s) {
        return new Date(s.start || s.startTime || s.date || 0).getTime() > last24h;
      });
      if (stage <= 3 && recentFt.length > 0) parts.push(recentFt.length + ' feeding' + (recentFt.length > 1 ? 's' : '') + ' in last 24h');
      if (stage >= 4) {
        var uniqueFoods = {};
        ftSessions.forEach(function (s) { if (s.foodName) uniqueFoods[s.foodName.toLowerCase()] = 1; });
        var foodCount = Object.keys(uniqueFoods).length;
        if (foodCount >= 5) parts.push(foodCount + ' different foods tried so far');
      }
    } catch {}

    try {
      var dtSessions = JSON.parse(localStorage.getItem(KEY_DT_SESSIONS) || '[]');
      var recentDt   = dtSessions.filter(function (s) {
        return new Date(s.start || s.startTime || s.startIso || s.date || 0).getTime() > last24h;
      });
      var totalMin = recentDt.reduce(function (acc, s) {
        return acc + (typeof (s.durationMin || s.duration) === 'number' ? (s.durationMin || s.duration) : 0);
      }, 0);
      if (totalMin > 0) {
        var h = Math.floor(totalMin / 60), m = totalMin % 60;
        parts.push((h > 0 ? h + 'h ' : '') + m + 'm sleep today');
      }
    } catch {}

    try {
      var blLogs  = JSON.parse(localStorage.getItem(KEY_BL_LOGS) || '[]');
      var last14d = Date.now() - 14 * 86400000;
      if (stage <= 3) {
        var tt = blLogs.filter(function (l) {
          return l.type === 'tummy' && new Date(l.timestamp || l.date || 0).getTime() > last24h;
        });
        if (tt.length > 0) parts.push(tt.length + ' tummy time session' + (tt.length > 1 ? 's' : '') + ' today');
      }
      if (stage >= 4) {
        var pottySuc = blLogs.filter(function (l) {
          return l.type === 'potty' && (l.outcome === 'pee_success' || l.outcome === 'poo_success') &&
            new Date(l.timestamp || l.date || 0).getTime() > last14d;
        });
        if (pottySuc.length >= 5) parts.push(pottySuc.length + ' potty successes in the last 2 weeks');
      }
    } catch {}

    if (stage >= 4 && wordLogActivated) {
      var wc = wordLogs.filter(function (w) { return !w.isPhrase; }).length;
      if (wc > 0) parts.push(wc + ' word' + (wc !== 1 ? 's' : '') + ' in vocabulary');
    }

    return parts.join(' · ');
  }

  // Smart cross-tracker prompts (Year 2)
  function computeSmartPrompt() {
    var stage = getStage();
    if (stage < 4) return null;

    try {
      var blLogs  = JSON.parse(localStorage.getItem(KEY_BL_LOGS) || '[]');
      var last7d  = Date.now() - 7 * 86400000;
      var pottyW  = blLogs.filter(function (l) {
        return l.type === 'potty' && (l.outcome === 'pee_success' || l.outcome === 'poo_success') &&
          new Date(l.timestamp || l.date || 0).getTime() > last7d;
      });
      if (pottyW.length >= 5) {
        return { emoji: '🚽', text: babyName + ' has been doing brilliantly with the potty — make sure you\'re logging those wins as milestones too.' };
      }
    } catch {}

    try {
      var ftSessions = JSON.parse(localStorage.getItem(KEY_FT_SESSIONS) || '[]');
      var uniqueFoods = {};
      ftSessions.forEach(function (s) { if (s.foodName) uniqueFoods[s.foodName.toLowerCase()] = 1; });
      if (Object.keys(uniqueFoods).length >= 20) {
        return { emoji: '🥕', text: babyName + ' has tried 20 different foods — that\'s worth celebrating. Any standout reactions or favourites?' };
      }
    } catch {}

    if (wordLogActivated) {
      var wc = wordLogs.filter(function (w) { return !w.isPhrase; }).length;
      if (wc >= 8 && wc <= 12) {
        return { emoji: '💬', text: babyName + '\'s word count is growing fast. The vocabulary explosion could happen any week now.' };
      }
    }

    return null;
  }

  // Confetti
  function launchConfetti() {
    var wrap = document.getElementById('ml-confetti');
    if (!wrap) return;
    wrap.innerHTML = '';
    for (var i = 0; i < 40; i++) {
      var p = document.createElement('div');
      p.className = 'ml-confetti-particle';
      p.style.cssText = [
        'left:'               + (Math.random() * 100) + '%',
        'background:'         + CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
        'width:'              + (6 + Math.random() * 6) + 'px',
        'height:'             + (6 + Math.random() * 6) + 'px',
        'border-radius:'      + (Math.random() > 0.5 ? '50%' : '2px'),
        'animation-delay:'    + (Math.random() * 0.8).toFixed(2) + 's',
        'animation-duration:' + (1.2 + Math.random()).toFixed(2) + 's',
      ].join(';');
      wrap.appendChild(p);
    }
  }

  // Photo compression
  function compressPhoto(file) {
    return new Promise(function (resolve) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var img = new Image();
        img.onload = function () {
          var maxW = 800, w = img.width, h = img.height;
          if (w > maxW) { h = Math.round(h * maxW / w); w = maxW; }
          var canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          resolve(canvas.toDataURL('image/jpeg', 0.72));
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  }

  function escHtml(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Topbar
  function renderTopbar() {
    var titleEl = document.getElementById('ml-story-title');
    var ageEl   = document.getElementById('ml-baby-age');
    if (titleEl) titleEl.textContent = babyName + "'s Story";
    var age = computeBabyAge();
    if (ageEl) ageEl.textContent = age ? age.label : '';
    updateWordBadge();
  }

  function updateWordBadge() {
    var badge     = document.getElementById('ml-word-badge');
    var countEl   = document.getElementById('ml-word-badge-count');
    var stage     = getStage();
    var wordCount = wordLogs.filter(function (w) { return !w.isPhrase; }).length;
    if (badge) badge.style.display = (stage >= 4 && wordLogActivated) ? 'flex' : 'none';
    if (countEl) countEl.textContent = wordCount;
  }

  // Prompt
  function renderPrompt() {
    var card    = document.getElementById('ml-prompt-card');
    var textEl  = document.getElementById('ml-prompt-text');
    var emojiEl = document.getElementById('ml-prompt-emoji');
    if (!card || !textEl) return;
    if (promptDismissed) { card.style.display = 'none'; return; }
    var age = computeBabyAge();
    if (!age) { card.style.display = 'none'; return; }

    var prompt;
    if (journalCadence === 'monthly') {
      var months = age.months || Math.floor(age.weeks / 4.33);
      prompt = MONTHLY_PROMPTS[MONTHLY_PROMPTS.length - 1];
      for (var i = 0; i < MONTHLY_PROMPTS.length; i++) {
        if (months <= MONTHLY_PROMPTS[i].maxMonths) { prompt = MONTHLY_PROMPTS[i]; break; }
      }
    } else {
      prompt = WEEKLY_PROMPTS[WEEKLY_PROMPTS.length - 1];
      for (var j = 0; j < WEEKLY_PROMPTS.length; j++) {
        if (age.weeks <= WEEKLY_PROMPTS[j].maxWeeks) { prompt = WEEKLY_PROMPTS[j]; break; }
      }
    }
    textEl.textContent = prompt.text;
    if (emojiEl) emojiEl.textContent = prompt.emoji;
    card.style.display = 'flex';
  }

  // Smart prompt
  function renderSmartPrompt() {
    var card = document.getElementById('ml-smart-prompt');
    var textEl = document.getElementById('ml-smart-prompt-text');
    var iconEl = document.getElementById('ml-smart-prompt-icon');
    if (!card) return;
    if (smartDismissed) { card.style.display = 'none'; return; }
    var sp = computeSmartPrompt();
    if (!sp) { card.style.display = 'none'; return; }
    if (textEl) textEl.textContent = sp.text;
    if (iconEl) iconEl.textContent = sp.emoji;
    card.style.display = 'flex';
  }

  // Timeline
  function renderTimeline() {
    var container = document.getElementById('ml-timeline');
    var empty     = document.getElementById('ml-timeline-empty');
    if (!container) return;

    var toRemove = [];
    for (var i = 0; i < container.children.length; i++) {
      if (container.children[i].id !== 'ml-timeline-empty') toRemove.push(container.children[i]);
    }
    toRemove.forEach(function (el) { el.remove(); });

    if (milestones.length === 0) {
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';

    var sorted = milestones.slice().sort(function (a, b) { return new Date(b.date) - new Date(a.date); });
    var groups = [], groupMap = {};
    var secondYearInserted = false;
    var ageMonths = getAgeMonths() || 0;

    sorted.forEach(function (m) {
      var d   = new Date(m.date);
      var key = d.getFullYear() + '-' + d.getMonth();
      if (!groupMap[key]) {
        var grp = { key: key, label: d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }), items: [], date: d };
        groupMap[key] = grp;
        groups.push(grp);
      }
      groupMap[key].items.push(m);
    });

    groups.forEach(function (g) {
      // Second year label at month 12 boundary
      if (!secondYearInserted && ageMonths >= 12 && babyBirthdate) {
        var grpMonths = Math.floor((g.date.getTime() - babyBirthdate.getTime()) / (30.44 * 86400000));
        if (grpMonths < 12) {
          secondYearInserted = true;
          var label = document.createElement('div');
          label.className = 'ml-year2-label';
          label.textContent = babyName + "'s Second Year";
          container.appendChild(label);
        }
      }

      var marker = document.createElement('div');
      marker.className = 'ml-month-marker';
      marker.textContent = g.label;
      container.appendChild(marker);

      g.items.forEach(function (m) {
        var catInfo = CATEGORIES[m.category] || { emoji: '✨' };
        var age     = ageAtDate(m.date);
        var card    = document.createElement('div');
        card.className = 'ml-milestone-card' + (m.isAuto ? ' ml-milestone-card--auto' : '');
        card.dataset.id = m.id;
        card.innerHTML =
          '<div class="ml-milestone-card__thumb">' +
            (m.photoUrl ? '<img src="' + escHtml(m.photoUrl) + '" alt="">' : '<span>' + (catInfo.emoji || '✨') + '</span>') +
          '</div>' +
          '<div class="ml-milestone-card__body">' +
            '<div class="ml-milestone-card__name">' + escHtml(m.name) + '</div>' +
            '<div class="ml-milestone-card__date">' + formatDate(m.date) + (age ? ' \xb7 ' + age : '') + '</div>' +
          '</div>';
        card.addEventListener('click', function (ms) { return function () { openDetailOverlay(ms); }; }(m));
        container.appendChild(card);
      });
    });
  }

  // Firsts grid
  function renderFirstsGrid() {
    var grid    = document.getElementById('ml-firsts-grid');
    var titleEl = document.getElementById('ml-firsts-title');
    if (!grid) return;
    if (titleEl) titleEl.textContent = babyName + "'s Firsts";
    grid.innerHTML = '';

    var catsToShow = ['motor', 'communication', 'social', 'feeding', 'family'];
    if (getStage() >= 4) catsToShow = catsToShow.concat(['cognitive', 'self_care']);

    catsToShow.forEach(function (catKey) {
      var info = CATEGORIES[catKey];
      if (!info) return;
      info.items.forEach(function (itemDef) {
        var itemName = itemDef.name || itemDef;
        var itemYear = itemDef.year || 1;
        if (firstsYearFilter === '1' && itemYear !== 1) return;
        if (firstsYearFilter === '2' && itemYear !== 2) return;

        var logged = null;
        for (var i = 0; i < milestones.length; i++) {
          if (milestones[i].name === itemName && milestones[i].category === catKey) { logged = milestones[i]; break; }
        }
        var tile = document.createElement('div');
        tile.className = 'ml-first-tile' + (logged ? ' ml-first-tile--logged' : ' ml-first-tile--empty') + (itemYear === 2 ? ' ml-first-tile--y2' : '');
        if (logged && logged.photoUrl) {
          tile.innerHTML =
            '<img class="ml-first-tile__photo" src="' + escHtml(logged.photoUrl) + '" alt="">' +
            '<div class="ml-first-tile__overlay"><div class="ml-first-tile__name">' + escHtml(itemName) + '</div><div class="ml-first-tile__age">' + ageAtDate(logged.date) + '</div></div>' +
            '<div class="ml-first-tile__star">★</div>';
        } else if (logged) {
          tile.innerHTML =
            '<div class="ml-first-tile__overlay"><div class="ml-first-tile__name">' + escHtml(itemName) + '</div><div class="ml-first-tile__age">' + ageAtDate(logged.date) + '</div></div>' +
            '<div class="ml-first-tile__star">★</div>';
        } else {
          tile.innerHTML =
            '<div class="ml-first-tile__overlay"><div class="ml-first-tile__empty-icon">' + info.emoji + '</div><div class="ml-first-tile__name">' + escHtml(itemName) + '</div></div>';
        }
        if (logged) {
          tile.addEventListener('click', function (ms) { return function () { openDetailOverlay(ms); }; }(logged));
        } else {
          tile.addEventListener('click', function (c, n) { return function () { openAddFlow(c, n); }; }(catKey, itemName));
        }
        grid.appendChild(tile);
      });
    });
  }

  // Word Log
  function activateWordLog() {
    wordLogActivated = true;
    savePrefs();
    applyStageUI(getStage());
    renderWordLogScreen();
    switchTab('words');
  }

  function renderWordLogScreen() {
    var unlock      = document.getElementById('ml-word-unlock');
    var active      = document.getElementById('ml-word-log-active');
    var countEl     = document.getElementById('ml-word-log-count');
    var wordList    = document.getElementById('ml-word-list');
    var phrasesSec  = document.getElementById('ml-phrases-section');
    var phraseList  = document.getElementById('ml-phrase-list');
    var cloudWrap   = document.getElementById('ml-word-cloud-wrap');
    var cloud       = document.getElementById('ml-word-cloud');
    var unlockTitle = document.getElementById('ml-word-unlock-title');
    var months      = getAgeMonths() || 0;

    if (!wordLogActivated) {
      if (unlock) {
        unlock.style.display = '';
        if (unlockTitle && months >= 12) unlockTitle.textContent = 'Time to start the Word Log';
      }
      if (active) active.style.display = 'none';
      return;
    }
    if (unlock) unlock.style.display = 'none';
    if (active) active.style.display = '';

    var words   = wordLogs.filter(function (w) { return !w.isPhrase; }).sort(function (a, b) { return new Date(b.firstSaid) - new Date(a.firstSaid); });
    var phrases = wordLogs.filter(function (w) { return w.isPhrase; }).sort(function (a, b) { return new Date(b.firstSaid) - new Date(a.firstSaid); });

    if (countEl) countEl.textContent = words.length + ' word' + (words.length !== 1 ? 's' : '');
    updateWordBadge();

    if (wordList) {
      wordList.innerHTML = '';
      if (words.length === 0) {
        wordList.innerHTML = '<div class="ml-word-empty">No words yet — tap + Add word to start the list.</div>';
      } else {
        words.forEach(function (w) {
          var row = document.createElement('div');
          row.className = 'ml-word-item';
          row.innerHTML =
            '<div class="ml-word-item__word">' + escHtml(w.word) + '</div>' +
            '<div class="ml-word-item__date">' + formatDate(w.firstSaid) + '</div>';
          wordList.appendChild(row);
        });
      }
    }

    if (phrasesSec && phraseList) {
      if (phrases.length > 0) {
        phrasesSec.style.display = '';
        phraseList.innerHTML = '';
        phrases.forEach(function (p) {
          var row = document.createElement('div');
          row.className = 'ml-word-item ml-word-item--phrase';
          row.innerHTML =
            '<div class="ml-word-item__word">' + escHtml(p.word) + '</div>' +
            '<div class="ml-word-item__date">' + formatDate(p.firstSaid) + '</div>';
          phraseList.appendChild(row);
        });
      } else {
        phrasesSec.style.display = 'none';
      }
    }

    if (cloudWrap && cloud && words.length >= 3) {
      cloudWrap.style.display = '';
      renderWordCloud(cloud, words);
    } else if (cloudWrap) {
      cloudWrap.style.display = 'none';
    }
  }

  function renderWordCloud(container, words) {
    container.innerHTML = '';
    var sorted = words.slice().sort(function (a, b) { return new Date(a.firstSaid) - new Date(b.firstSaid); });
    sorted.forEach(function (w, idx) {
      var span = document.createElement('span');
      span.className = 'ml-word-cloud__word';
      var sizeFactor = Math.max(0, 1 - idx / sorted.length);
      span.style.fontSize = (12 + sizeFactor * 14) + 'px';
      span.style.opacity  = (0.5 + sizeFactor * 0.5).toFixed(2);
      span.textContent = w.word;
      container.appendChild(span);
    });
  }

  function openWordOverlay() {
    var overlay = document.getElementById('ml-overlay-word');
    var input   = document.getElementById('ml-word-input');
    var dateEl  = document.getElementById('ml-word-date');
    var hint    = document.getElementById('ml-phrase-hint');
    var notes   = document.getElementById('ml-word-notes');
    if (!overlay) return;
    if (input) input.value = '';
    if (dateEl) dateEl.value = todayIso();
    if (hint) hint.style.display = 'none';
    if (notes) notes.value = '';
    overlay.style.display = 'flex';
    setTimeout(function () { if (input) input.focus(); }, 100);
  }

  function closeWordOverlay() {
    var overlay = document.getElementById('ml-overlay-word');
    if (overlay) overlay.style.display = 'none';
  }

  function saveWord() {
    var input  = document.getElementById('ml-word-input');
    var dateEl = document.getElementById('ml-word-date');
    var notes  = document.getElementById('ml-word-notes');
    var val    = input ? input.value.trim() : '';
    if (!val) return;

    var isPhrase = val.trim().split(/\s+/).length >= 2;
    var entry = {
      id:        Date.now().toString(36) + Math.random().toString(36).slice(2, 5),
      word:      val,
      isPhrase:  isPhrase,
      firstSaid: (dateEl && dateEl.value) ? new Date(dateEl.value).toISOString() : new Date().toISOString(),
      notes:     notes ? notes.value.trim() : '',
    };

    wordLogs.push(entry);
    saveData();
    closeWordOverlay();
    renderWordLogScreen();

    if (!isPhrase) checkWordCountMilestone();
  }

  function checkWordCountMilestone() {
    var wc = wordLogs.filter(function (w) { return !w.isPhrase; }).length;
    for (var i = 0; i < WORD_COUNT_THRESHOLDS.length; i++) {
      var threshold = WORD_COUNT_THRESHOLDS[i];
      if (wc === threshold) {
        var alreadyLogged = milestones.some(function (m) { return m.name === WORD_COUNT_NAMES[threshold]; });
        if (!alreadyLogged) {
          pendingWordMilestone = { name: WORD_COUNT_NAMES[threshold], count: threshold };
          showAutoConfirm(babyName + ' knows ' + threshold + ' word' + (threshold !== 1 ? 's' : '') + '!');
        }
        break;
      }
    }
  }

  function showAutoConfirm(text) {
    var banner  = document.getElementById('ml-auto-confirm');
    var textEl  = document.getElementById('ml-auto-confirm-text');
    if (!banner) return;
    if (textEl) textEl.textContent = text;
    banner.style.display = 'flex';
    banner.classList.add('ml-auto-confirm--visible');
  }

  function hideAutoConfirm() {
    var banner = document.getElementById('ml-auto-confirm');
    if (banner) { banner.classList.remove('ml-auto-confirm--visible'); banner.style.display = 'none'; }
    pendingWordMilestone = null;
  }

  // Tab switching
  function switchTab(tab) {
    document.querySelectorAll('.ml-tab').forEach(function (btn) {
      btn.classList.toggle('ml-tab--active', btn.dataset.tab === tab);
    });
    document.querySelectorAll('.ml-screen').forEach(function (s) {
      s.classList.toggle('ml-screen--active', s.id === 'ml-screen-' + tab);
    });
    if (tab === 'firsts') renderFirstsGrid();
    if (tab === 'words')  renderWordLogScreen();
  }

  // Add flow
  function openAddFlow(catOverride, nameOverride, milestoneYearOverride, isAutoTriggered) {
    flow = {
      step: 'pick',
      cat: catOverride || 'motor',
      milestoneName: nameOverride || '',
      photoDataUrl: '',
      narrative: '',
      crossCtx: '',
      milestoneYear: milestoneYearOverride || 1,
      isAuto: !!isAutoTriggered,
    };
    var overlay = document.getElementById('ml-overlay-add');
    if (overlay) { overlay.style.display = 'flex'; }
    if (nameOverride) {
      advanceFromPick();
    } else {
      goToStep('pick');
      renderCatPills();
      renderMilestoneList();
    }
  }

  function closeAddFlow() {
    stopCamera();
    var overlay = document.getElementById('ml-overlay-add');
    if (overlay) overlay.style.display = 'none';
  }

  // ── Camera ────────────────────────────────────────────────────────────────
  var cameraStream   = null;
  var cameraFacing   = 'environment';

  function startCamera() {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      document.getElementById('ml-gallery-input') && document.getElementById('ml-gallery-input').click();
      return;
    }
    navigator.mediaDevices.getUserMedia({ video: { facingMode: cameraFacing }, audio: false })
      .then(function (stream) {
        cameraStream = stream;
        var video = document.getElementById('ml-camera-video');
        if (video) { video.srcObject = stream; video.play(); }
        var wrap    = document.getElementById('ml-camera-wrap');
        var content = document.getElementById('ml-capture-content');
        if (wrap)    wrap.style.display    = 'flex';
        if (content) content.style.display = 'none';
      })
      .catch(function () {
        var fi = document.getElementById('ml-gallery-input');
        if (fi) fi.click();
      });
  }

  function snapCamera() {
    var video  = document.getElementById('ml-camera-video');
    var canvas = document.getElementById('ml-camera-canvas');
    if (!video || !canvas) return;
    canvas.width  = video.videoWidth  || 640;
    canvas.height = video.videoHeight || 480;
    canvas.getContext('2d').drawImage(video, 0, 0);
    canvas.toBlob(function (blob) {
      stopCamera();
      if (!blob) return;
      compressPhoto(blob).then(function (dataUrl) {
        flow.photoDataUrl = dataUrl;
        var img = document.getElementById('ml-capture-img');
        if (img) img.src = dataUrl;
        var capturePreview = document.getElementById('ml-capture-preview');
        var captureContent = document.getElementById('ml-capture-content');
        if (capturePreview) capturePreview.style.display = 'flex';
        if (captureContent) captureContent.style.display = 'none';
      });
    }, 'image/jpeg', 0.82);
  }

  function stopCamera() {
    if (cameraStream) {
      cameraStream.getTracks().forEach(function (t) { t.stop(); });
      cameraStream = null;
    }
    var video   = document.getElementById('ml-camera-video');
    var wrap    = document.getElementById('ml-camera-wrap');
    var content = document.getElementById('ml-capture-content');
    if (video)   video.srcObject    = null;
    if (wrap)    wrap.style.display = 'none';
    if (content) content.style.display = 'flex';
  }

  function goToStep(step) {
    ['pick', 'celebrate', 'capture', 'note', 'share'].forEach(function (s) {
      var el = document.getElementById('ml-step-' + s);
      if (el) el.style.display = s === step ? 'flex' : 'none';
    });
    flow.step = step;
  }

  function openNoteStep() {
    goToStep('note');
    var forEl = document.getElementById('ml-note-paper-for');
    if (forEl) forEl.textContent = 'For ' + (babyName || 'your little one') + ' — ' + flow.milestoneName;
    var noteInput = document.getElementById('ml-note-input');
    if (noteInput) noteInput.value = '';
  }

  function renderCatPills() {
    document.querySelectorAll('.ml-cat-pill').forEach(function (btn) {
      btn.classList.toggle('ml-cat-pill--active', btn.dataset.cat === flow.cat);
    });
  }

  function renderMilestoneList() {
    var list       = document.getElementById('ml-milestone-list');
    var customWrap = document.getElementById('ml-custom-wrap');
    if (!list) return;
    list.innerHTML = '';

    if (flow.cat === 'custom') {
      if (customWrap) customWrap.style.display = 'flex';
      var ci = document.getElementById('ml-custom-input');
      if (ci) ci.value = '';
      return;
    }
    if (customWrap) customWrap.style.display = 'none';

    var cat = CATEGORIES[flow.cat];
    if (!cat) return;

    cat.items.forEach(function (itemDef) {
      var itemName = itemDef.name || itemDef;
      var itemYear = itemDef.year || 1;
      var alreadyLogged = milestones.some(function (m) { return m.name === itemName && m.category === flow.cat; });
      var btn = document.createElement('button');
      btn.className = 'ml-milestone-pill' + (alreadyLogged ? ' ml-milestone-pill--logged' : '') + (itemYear === 2 ? ' ml-milestone-pill--y2' : '');
      btn.innerHTML =
        '<span class="ml-milestone-pill__icon">' + (cat.emoji || '✨') + '</span>' +
        '<span class="ml-milestone-pill__name">' + escHtml(itemName) + '</span>' +
        (alreadyLogged ? '<span class="ml-milestone-pill__check">✓</span>' : '');
      btn.addEventListener('click', function (n, yr) {
        return function () { flow.milestoneName = n; flow.milestoneYear = yr; advanceFromPick(); };
      }(itemName, itemYear));
      list.appendChild(btn);
    });
  }

  function advanceFromPick() {
    if (!flow.milestoneName.trim()) return;
    goToStep('celebrate');
    var nameEl  = document.getElementById('ml-celebrate-name');
    var msEl    = document.getElementById('ml-celebrate-milestone');
    var ageEl   = document.getElementById('ml-celebrate-age');
    var autoBadge = document.getElementById('ml-celebrate-auto-badge');
    if (nameEl) nameEl.textContent = babyName;
    if (msEl)   msEl.textContent   = flow.milestoneName;
    var age = computeBabyAge();
    if (ageEl) ageEl.textContent = age ? age.label : '';
    if (autoBadge) autoBadge.style.display = flow.isAuto ? '' : 'none';
    launchConfetti();
    setTimeout(function () { if (flow.step === 'celebrate') goToStep('capture'); }, 2500);
  }

  // Save milestone
  function saveMilestone(shareAfter) {
    var noteEl = document.getElementById('ml-note-input');
    var note   = noteEl ? noteEl.value.trim() : '';

    var milestone = {
      id:        Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
      name:      flow.milestoneName,
      category:  flow.cat,
      date:      new Date().toISOString(),
      photoUrl:  flow.photoDataUrl,
      note:      note,
      year:      flow.milestoneYear || 1,
      isAuto:    flow.isAuto || false,
    };

    milestones.unshift(milestone);
    saveData();
    renderTimeline();

    if (shareAfter) { openShareStep(milestone); }
    else            { closeAddFlow(); }
  }

  function openShareStep(milestone) {
    goToStep('share');
    var photoEl = document.getElementById('ml-share-card-photo');
    var msEl    = document.getElementById('ml-share-card-milestone');
    var metaEl  = document.getElementById('ml-share-card-meta');
    if (photoEl) {
      if (milestone.photoUrl) {
        photoEl.style.backgroundImage    = 'url(' + milestone.photoUrl + ')';
        photoEl.style.backgroundSize     = 'cover';
        photoEl.style.backgroundPosition = 'center';
        photoEl.style.display = 'block';
      } else {
        photoEl.style.display = 'none';
      }
    }
    if (msEl)   msEl.textContent  = milestone.name;
    var age = ageAtDate(milestone.date);
    if (metaEl) metaEl.textContent = babyName + ' \xb7 ' + formatDate(milestone.date) + (age ? ' \xb7 ' + age : '');

    var pageUrl   = encodeURIComponent(window.location.href);
    var shareText = encodeURIComponent(babyName + " just hit a milestone: " + milestone.name + " 🎉");
    var smsBody   = encodeURIComponent(babyName + " just hit a milestone: " + milestone.name + "! " + window.location.href);

    var wa  = document.getElementById('ml-share-whatsapp');
    var ig  = document.getElementById('ml-share-instagram');
    var fb  = document.getElementById('ml-share-facebook');
    var msg = document.getElementById('ml-share-message');
    if (wa)  wa.href  = "https://wa.me/?text=" + shareText + "%20" + pageUrl;
    if (ig)  ig.href  = "https://www.instagram.com/";
    if (fb)  fb.href  = "https://www.facebook.com/sharer/sharer.php?u=" + pageUrl;
    if (msg) msg.setAttribute('data-sms', "sms:?body=" + smsBody);

    var dropdown = document.getElementById('ml-share-more-dropdown');
    if (dropdown) dropdown.style.display = 'none';
  }

  function downloadNotes() {
    var withNotes = milestones.filter(function (m) { return m.note; });
    if (!withNotes.length) {
      var sub = document.getElementById('ml-settings-notes-sub');
      if (sub) { sub.textContent = 'No notes yet — add a note when logging a milestone.'; }
      return;
    }
    var sorted = withNotes.slice().sort(function (a, b) { return new Date(a.date) - new Date(b.date); });
    var html = '<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8">' +
      '<meta name="viewport" content="width=device-width,initial-scale=1">' +
      '<title>' + escHtml(babyName) + "'s Milestone Notes</title>" +
      '<link href="https://fonts.googleapis.com/css2?family=Newsreader:ital,wght@0,400;0,500;1,400&family=Caveat:wght@400;500&display=swap" rel="stylesheet">' +
      '<style>' +
        'body{font-family:\'Newsreader\',Georgia,serif;background:#FAFAF8;color:#1E2E26;padding:48px 24px;max-width:640px;margin:0 auto}' +
        'h1{font-size:clamp(28px,5vw,40px);font-weight:400;margin-bottom:4px;letter-spacing:-.02em}' +
        '.sub{font-size:13px;color:#9A8C6A;margin-bottom:48px;letter-spacing:.04em;text-transform:uppercase}' +
        '.entry{margin-bottom:44px}' +
        '.entry-name{font-size:19px;font-weight:500;margin-bottom:2px;letter-spacing:-.01em}' +
        '.entry-date{font-size:11px;color:#9A8C6A;margin-bottom:14px;letter-spacing:.05em;text-transform:uppercase}' +
        '.entry-note{font-family:\'Caveat\',cursive;font-size:21px;color:#2A2010;line-height:1.55;' +
          'background:#F9F5EA;padding:18px 20px 18px 52px;border-radius:3px;' +
          'box-shadow:2px 3px 0 rgba(200,185,150,.25);' +
          'background-image:repeating-linear-gradient(transparent 0,transparent 29px,rgba(180,160,110,.2) 29px,rgba(180,160,110,.2) 30px);' +
          'background-position:0 46px}' +
        '.footer{margin-top:56px;padding-top:20px;border-top:1px solid #EDE8DE;font-size:12px;color:#B0A090;text-align:center}' +
      '</style></head><body>' +
      '<h1>' + escHtml(babyName) + "'s Milestone Notes</h1>" +
      '<div class="sub">' + withNotes.length + ' note' + (withNotes.length !== 1 ? 's' : '') + '</div>';
    sorted.forEach(function (m) {
      html += '<div class="entry">' +
        '<div class="entry-name">' + escHtml(m.name) + '</div>' +
        '<div class="entry-date">' + formatDate(m.date) + '</div>' +
        '<div class="entry-note">' + escHtml(m.note).replace(/\n/g, '<br>') + '</div>' +
        '</div>';
    });
    html += '<div class="footer">Captured with Birch 🌿</div></body></html>';
    var blob = new Blob([html], { type: 'text/html' });
    var url  = URL.createObjectURL(blob);
    var a    = document.createElement('a');
    a.href     = url;
    a.download = (babyName || 'Baby').replace(/\s+/g, '-') + '-milestone-notes.html';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  // Detail overlay
  function openDetailOverlay(milestone) {
    var overlay     = document.getElementById('ml-overlay-detail');
    var titleEl     = document.getElementById('ml-detail-title');
    var photoEl     = document.getElementById('ml-detail-photo');
    var metaEl      = document.getElementById('ml-detail-meta');
    var ctxEl       = document.getElementById('ml-detail-ctx');
    var ctxText     = document.getElementById('ml-detail-ctx-text');
    if (!overlay) return;
    if (titleEl)      titleEl.textContent  = milestone.name;
    var age = ageAtDate(milestone.date);
    if (metaEl)       metaEl.textContent   = formatDate(milestone.date) + (age ? ' \xb7 ' + age : '');
    if (photoEl)      photoEl.innerHTML    = milestone.photoUrl ? '<img src="' + escHtml(milestone.photoUrl) + '" alt="' + escHtml(milestone.name) + '" style="width:100%;height:100%;object-fit:cover">' : '';
    if (ctxEl && ctxText) {
      if (milestone.crossCtx) { ctxText.textContent = milestone.crossCtx; ctxEl.style.display = 'flex'; }
      else                    { ctxEl.style.display = 'none'; }
    }
    var noteEl = document.getElementById('ml-detail-note');
    if (noteEl) {
      if (milestone.note) { noteEl.textContent = milestone.note; noteEl.style.display = 'block'; }
      else                { noteEl.style.display = 'none'; }
    }
    overlay.style.display = 'flex';
  }

  function closeDetailOverlay() {
    var overlay = document.getElementById('ml-overlay-detail');
    if (overlay) overlay.style.display = 'none';
  }

  // Init
  function init() {
    loadData();
    var stage = getStage();
    applyStageUI(stage);
    renderTopbar();
    renderPrompt();
    renderSmartPrompt();
    renderTimeline();

    // Tabs
    document.querySelectorAll('.ml-tab').forEach(function (btn) {
      btn.addEventListener('click', function () { switchTab(btn.dataset.tab); });
    });

    // FAB + Add button
    var fab    = document.getElementById('ml-fab');
    var addBtn = document.getElementById('ml-add-btn');
    if (fab)    fab.addEventListener('click',    function () { openAddFlow(); });
    if (addBtn) addBtn.addEventListener('click', function () { openAddFlow(); });

    // Word badge → open word tab
    var wordBadge = document.getElementById('ml-word-badge');
    if (wordBadge) wordBadge.addEventListener('click', function () { switchTab('words'); });

    // Topbar settings
    var settingsBtn = document.getElementById('ml-topbar-settings');
    if (settingsBtn) settingsBtn.addEventListener('click', function () {
      applyStageUI(getStage());
      var overlay = document.getElementById('ml-overlay-settings');
      if (overlay) overlay.style.display = 'flex';
    });

    // Settings close
    var settingsClose = document.getElementById('ml-settings-close');
    if (settingsClose) settingsClose.addEventListener('click', function () {
      var overlay = document.getElementById('ml-overlay-settings');
      if (overlay) overlay.style.display = 'none';
    });

    // Journal cadence
    document.querySelectorAll('.ml-cadence-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        journalCadence = btn.dataset.cadence;
        savePrefs();
        applyStageUI(getStage());
        renderPrompt();
      });
    });

    // Word log toggle in settings
    var wlToggle = document.getElementById('ml-settings-wordlog-toggle');
    if (wlToggle) wlToggle.addEventListener('click', function () {
      wordLogActivated = !wordLogActivated;
      savePrefs();
      applyStageUI(getStage());
      renderWordLogScreen();
    });

    // Prompt dismiss / log
    var dismissBtn = document.getElementById('ml-prompt-dismiss');
    if (dismissBtn) dismissBtn.addEventListener('click', function () {
      promptDismissed = true;
      var card = document.getElementById('ml-prompt-card');
      if (card) card.style.display = 'none';
    });
    var logBtn = document.getElementById('ml-prompt-log');
    if (logBtn) logBtn.addEventListener('click', function () { openAddFlow(); });

    // Smart prompt dismiss
    var spDismiss = document.getElementById('ml-smart-prompt-dismiss');
    if (spDismiss) spDismiss.addEventListener('click', function () {
      smartDismissed = true;
      var card = document.getElementById('ml-smart-prompt');
      if (card) card.style.display = 'none';
    });

    // Year filter
    var yearFilter = document.getElementById('ml-year-filter');
    if (yearFilter) yearFilter.addEventListener('click', function (e) {
      var btn = e.target.closest('.ml-year-pill');
      if (!btn) return;
      firstsYearFilter = btn.dataset.year;
      document.querySelectorAll('.ml-year-pill').forEach(function (b) {
        b.classList.toggle('ml-year-pill--active', b.dataset.year === firstsYearFilter);
      });
      renderFirstsGrid();
    });

    // Category pills
    var pillsContainer = document.getElementById('ml-cat-pills');
    if (pillsContainer) pillsContainer.addEventListener('click', function (e) {
      var btn = e.target.closest('.ml-cat-pill');
      if (!btn) return;
      flow.cat = btn.dataset.cat;
      renderCatPills();
      renderMilestoneList();
    });

    // Pick close
    var pickClose = document.getElementById('ml-pick-close');
    if (pickClose) pickClose.addEventListener('click', closeAddFlow);

    // Custom input
    var customInput   = document.getElementById('ml-custom-input');
    var customConfirm = document.getElementById('ml-custom-confirm');
    function submitCustom() {
      var val = customInput ? customInput.value.trim() : '';
      if (!val) return;
      flow.milestoneName = val; flow.cat = 'custom'; flow.milestoneYear = 1;
      advanceFromPick();
    }
    if (customConfirm) customConfirm.addEventListener('click', submitCustom);
    if (customInput)   customInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') submitCustom(); });

    // Capture back
    var captureBack = document.getElementById('ml-capture-back');
    if (captureBack) captureBack.addEventListener('click', function () { stopCamera(); goToStep('pick'); renderCatPills(); renderMilestoneList(); });

    // Camera + gallery inputs
    var galleryInput   = document.getElementById('ml-gallery-input');
    var capturePreview = document.getElementById('ml-capture-preview');
    var captureContent = document.getElementById('ml-capture-content');

    var cameraBtn  = document.getElementById('ml-camera-btn');
    var cameraSnap = document.getElementById('ml-camera-snap');
    var cameraStop = document.getElementById('ml-camera-stop');
    var cameraFlip = document.getElementById('ml-camera-flip');
    if (cameraBtn)  cameraBtn.addEventListener('click',  startCamera);
    if (cameraSnap) cameraSnap.addEventListener('click', snapCamera);
    if (cameraStop) cameraStop.addEventListener('click', stopCamera);
    if (cameraFlip) cameraFlip.addEventListener('click', function () {
      cameraFacing = cameraFacing === 'environment' ? 'user' : 'environment';
      stopCamera();
      startCamera();
    });

    function handleGalleryPhoto(file) {
      if (!file) return;
      compressPhoto(file).then(function (dataUrl) {
        flow.photoDataUrl = dataUrl;
        var img = document.getElementById('ml-capture-img');
        if (img) img.src = dataUrl;
        if (capturePreview) capturePreview.style.display = 'flex';
        if (captureContent) captureContent.style.display = 'none';
      });
    }
    if (galleryInput) galleryInput.addEventListener('change', function (e) { handleGalleryPhoto(e.target.files[0]); });

    var captureRetake = document.getElementById('ml-capture-retake');
    if (captureRetake) captureRetake.addEventListener('click', function () {
      flow.photoDataUrl = '';
      if (capturePreview) capturePreview.style.display = 'none';
      if (captureContent) captureContent.style.display = 'flex';
    });

    var captureUse         = document.getElementById('ml-capture-use');
    var captureSkipToSave  = document.getElementById('ml-capture-skip-to-save');
    var captureSkip        = document.getElementById('ml-capture-skip');
    if (captureUse)        captureUse.addEventListener('click',        function () { openNoteStep(); });
    if (captureSkipToSave) captureSkipToSave.addEventListener('click', function () { saveMilestone(true); });
    if (captureSkip)       captureSkip.addEventListener('click',       function () { flow.photoDataUrl = ''; openNoteStep(); });

    // Note step
    var noteBack      = document.getElementById('ml-note-back');
    var noteSave      = document.getElementById('ml-note-save');
    var noteSaveQuiet = document.getElementById('ml-note-save-quiet');
    if (noteBack)      noteBack.addEventListener('click',      function () { goToStep(flow.photoDataUrl ? 'capture' : 'capture'); });
    if (noteSave)      noteSave.addEventListener('click',      function () { saveMilestone(true); });
    if (noteSaveQuiet) noteSaveQuiet.addEventListener('click', function () { saveMilestone(false); });

    // Share close
    var shareClose = document.getElementById('ml-share-close');
    if (shareClose) shareClose.addEventListener('click', closeAddFlow);

    // Message (SMS)
    var shareMessage = document.getElementById('ml-share-message');
    if (shareMessage) shareMessage.addEventListener('click', function () {
      var smsUrl = shareMessage.getAttribute('data-sms') || ('sms:?body=' + encodeURIComponent(window.location.href));
      window.location.href = smsUrl;
    });

    // More dropdown toggle
    var moreBtn      = document.getElementById('ml-share-more-btn');
    var moreDropdown = document.getElementById('ml-share-more-dropdown');
    if (moreBtn && moreDropdown) {
      moreBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = moreDropdown.style.display !== 'none';
        moreDropdown.style.display = open ? 'none' : 'block';
      });
      document.addEventListener('click', function () { moreDropdown.style.display = 'none'; });
    }

    // Copy link (inside More dropdown)
    var shareCopy = document.getElementById('ml-share-copy');
    if (shareCopy) shareCopy.addEventListener('click', function () {
      var label = document.getElementById('ml-copy-label');
      navigator.clipboard && navigator.clipboard.writeText(window.location.href).then(function () {
        if (label) { label.textContent = 'Copied!'; setTimeout(function () { label.textContent = 'Copy link'; }, 2000); }
      });
      if (moreDropdown) moreDropdown.style.display = 'none';
    });

    // Download notes (settings)
    var downloadBtn = document.getElementById('ml-settings-download-notes');
    if (downloadBtn) downloadBtn.addEventListener('click', downloadNotes);

    // Detail close
    var detailClose = document.getElementById('ml-detail-close');
    if (detailClose) detailClose.addEventListener('click', closeDetailOverlay);

    // Word log screen
    var wordUnlockBtn = document.getElementById('ml-word-unlock-btn');
    if (wordUnlockBtn) wordUnlockBtn.addEventListener('click', activateWordLog);

    var wordAddBtn = document.getElementById('ml-word-add-btn');
    if (wordAddBtn) wordAddBtn.addEventListener('click', openWordOverlay);

    // Word overlay
    var wordClose = document.getElementById('ml-word-close');
    if (wordClose) wordClose.addEventListener('click', closeWordOverlay);

    var wordSave = document.getElementById('ml-word-save');
    if (wordSave) wordSave.addEventListener('click', saveWord);

    var wordInput = document.getElementById('ml-word-input');
    if (wordInput) {
      wordInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') saveWord(); });
      wordInput.addEventListener('input', function () {
        var val   = wordInput.value.trim();
        var hint  = document.getElementById('ml-phrase-hint');
        var words = val.split(/\s+/);
        if (hint) hint.style.display = (words.length >= 2 && val.length > 0) ? '' : 'none';
      });
    }

    var phraseBtn = document.getElementById('ml-phrase-milestone-btn');
    if (phraseBtn) phraseBtn.addEventListener('click', function () {
      var already = milestones.some(function (m) { return m.name === 'First two-word combination'; });
      if (!already) {
        closeWordOverlay();
        openAddFlow('communication', 'First two-word combination', 2);
      }
    });

    // Auto-confirm banner
    var autoYes = document.getElementById('ml-auto-confirm-yes');
    var autoNo  = document.getElementById('ml-auto-confirm-no');
    if (autoYes) autoYes.addEventListener('click', function () {
      if (pendingWordMilestone) {
        hideAutoConfirm();
        openAddFlow('communication', pendingWordMilestone.name, 2, true);
      }
    });
    if (autoNo) autoNo.addEventListener('click', hideAutoConfirm);

    // Word log: show unlock prompt at 10+ months even if not activated
    var months = getAgeMonths() || 0;
    if (months >= 10 && !wordLogActivated) {
      var unlockEl = document.getElementById('ml-word-unlock');
      if (unlockEl) unlockEl.style.display = '';
      var wlSection = document.getElementById('ml-settings-wordlog-section');
      if (wlSection) wlSection.style.display = '';
    }

    // Child selector
    var childSelectorBtn = document.getElementById('ml-child-selector-btn');
    if (childSelectorBtn) childSelectorBtn.addEventListener('click', switchMilestoneChild);
    hydrateFromSharedProfile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
